<div class="flex flex-col gap-3">
  <div class="rounded-xl border border-outline dark:border-outline-darkmode overflow-hidden">
    <table class="min-w-full">
      <thead>
        <tr>
          <th
            class="text-sm font-semibold pl-6 pr-0.5 py-3.5 text-start bg-surface-variant-magic dark:bg-surface-variant-magic-darkmode rounded-tl-xl"
          >
            @if (view() === 'PRICE') {
              {{ 'cockpit.supplierContracts.details.price.tableHeader.priceComponent' | transloco }}
            } @else {
              {{ 'cockpit.supplierContracts.details.price.tableHeader.costComponent' | transloco }}
            }
          </th>
          <th
            class="text-sm font-semibold py-3.5 px-0.5 text-start bg-surface-variant-magic dark:bg-surface-variant-magic-darkmode"
          >
            {{ 'cockpit.supplierContracts.details.price.tableHeader.validRange' | transloco }}
          </th>
          <th
            class="text-sm font-semibold py-3.5 px-0.5 text-end bg-surface-variant-magic dark:bg-surface-variant-magic-darkmode"
          >
            {{ 'cockpit.supplierContracts.details.price.tableHeader.sum' | transloco }}
          </th>
          <th
            class="text-sm font-semibold pr-6 pl-0.5 py-3.5 text-end bg-surface-variant-magic dark:bg-surface-variant-magic-darkmode rounded-tr-xl"
          >
            {{ 'cockpit.supplierContracts.details.price.tableHeader.unit' | transloco }}
          </th>
        </tr>
      </thead>
      <tbody>
        @for (section of components(); track section.titleKey) {
          @if (section.priceComponents.length) {
            <tr
              class="text-sm font-semibold border-y border-outline dark:border-outline-darkmode text-on-surface-subtle dark:text-on-surface-subtle-darkmode bg-surface-variant-magic dark:bg-surface-variant-magic-darkmode"
            >
              <td colspan="4" class="px-6 py-2">
                {{ section.titleKey | transloco }}
              </td>
            </tr>
          }
          @for (component of section.priceComponents; track $index; let isLast = $last) {
            <tr
              class="text-sm border-outline dark:border-outline-darkmode"
              [class.border-b]="!isLast"
            >
              @if (component.isIndexPrice) {
                <td class="pl-6 pr-0.5 py-3.5 font-medium">
                  {{ 'cockpit.supplierContracts.details.price.indexPriceLabel' | transloco }}
                </td>
              } @else {
                <td class="pl-6 pr-0.5 py-3.5 font-medium">{{ component.label }}</td>
              }
              <td class="py-3.5 px-0.5 flex flex-wrap gap-2">
                @if (component.validFrom) {
                  <ui-badge>{{ component.validFrom | date: 'dd.MM.yyyy' }}</ui-badge>
                }
                @if (component.validTo) {
                  <ui-badge>{{ component.validTo | date: 'dd.MM.yyyy' }}</ui-badge>
                }
              </td>
              <td
                class="py-3.5 px-0.5 font-normal text-end tabular-nums text-sm overflow-hidden text-ellipsis whitespace-nowrap"
                [uiTooltip]="
                  (component.amount
                    | priceRange: (component.type === 'PRICE' ? 'CENTS' : 'EURO') : -1) +
                  ' ' +
                  (component.type === 'PRICE'
                    ? (component.currencyUnit | priceCurrencyUnit | transloco) +
                      '/' +
                      (component.referenceUnit | priceReferenceUnit | transloco)
                    : ('cockpit.supplierContracts.units.currencyUnit.EURO' | transloco))
                "
              >
                {{
                  component.amount | priceRange: (component.type === 'PRICE' ? 'CENTS' : 'EURO') : 2
                }}
              </td>
              <td
                class="pr-6 pl-0.5 py-3.5 font-normal text-end overflow-hidden text-ellipsis whitespace-nowrap"
              >
                @if (component.type === 'PRICE') {
                  {{ component.currencyUnit | priceCurrencyUnit | transloco }}/{{
                    component.referenceUnit | priceReferenceUnit | transloco
                  }}
                } @else {
                  {{ 'cockpit.supplierContracts.units.currencyUnit.EURO' | transloco }}
                }
              </td>
            </tr>
          }
        }
      </tbody>
    </table>
  </div>
  <div class="flex justify-end text-sm">
    <div class="block md:grid lg:block xl:grid grid-cols-12 gap-y-4">
      @if (view() === 'PRICE') {
        <span class="col-span-9 line-clamp-1 leading-6 font-semibold">
          {{ 'cockpit.supplierContracts.details.price.table.energyPriceNet' | transloco }}
        </span>
        <span
          class="col-span-3 text-end line-clamp-1 leading-6 font-normal text-on-surface-subtle dark:text-on-surface-subtle-darkmode"
        >
          {{ energyPrice() | priceRange: 'CENTS' : 2 }}
          {{ 'cockpit.supplierContracts.units.currencyUnit.CENTS' | transloco }}/{{
            'cockpit.supplierContracts.units.referenceUnit.KWH' | transloco
          }}
        </span>
        <span class="col-span-9 line-clamp-1 leading-6 font-semibold">
          {{ 'cockpit.supplierContracts.details.price.table.energyPriceNetWithTaxes' | transloco }}
        </span>
        <span
          class="col-span-3 text-end line-clamp-1 leading-6 font-normal text-on-surface-subtle dark:text-on-surface-subtle-darkmode"
        >
          {{ energyPriceWithTaxes() | priceRange: 'CENTS' : 2 }}
          {{ 'cockpit.supplierContracts.units.currencyUnit.CENTS' | transloco }}/{{
            'cockpit.supplierContracts.units.referenceUnit.KWH' | transloco
          }}
        </span>
      } @else {
        <span class="col-span-9 line-clamp-1 leading-6 font-semibold">
          {{ 'cockpit.supplierContracts.details.price.table.energyCostNet' | transloco }}
        </span>
        <span
          class="col-span-3 text-end line-clamp-1 leading-6 font-normal text-on-surface-subtle dark:text-on-surface-subtle-darkmode"
        >
          {{ energyCost() | priceRange: 'EURO' : 2 }}
          {{ 'cockpit.supplierContracts.units.currencyUnit.EURO' | transloco }}
        </span>
        <span class="col-span-9 line-clamp-1 leading-6 font-semibold">
          {{ 'cockpit.supplierContracts.details.price.table.energyCostNetWithTaxes' | transloco }}
        </span>
        <span
          class="col-span-3 text-end line-clamp-1 leading-6 font-normal text-on-surface-subtle dark:text-on-surface-subtle-darkmode"
        >
          {{ energyCostWithTaxes() | priceRange: 'EURO' : 2 }}
          {{ 'cockpit.supplierContracts.units.currencyUnit.EURO' | transloco }}
        </span>
      }
    </div>
  </div>
</div>
